export default __webpack_public_path__ + "static/media/request-border.412f6a3c.svg";